import Vue from "vue";
import Router from "vue-router";

// Containers
const TheContainer = () => import("@/containers/TheContainer");

// Views
const ProductIndex = () => import("@/views/pages/product/Index");
const ProductDetail = () => import("@/views/pages/product/Details");
// const ReturnIndex = () => import("@/views/pages/return/Index");
// const ReturnDetail = () => import("@/views/pages/return/Details");
const OrderIndex = () => import("@/views/pages/order/Index");
const OrderDetail = () => import("@/views/pages/order/Details");
const InventoryIndex = () => import("@/views/pages/inventory/Index");
const InventoryAutoConfig = () =>
  import(
    "@/views/pages/inventory/components/inventory-auto/InventoryAutoConfig"
  );
const InventoryCreateBook = () =>
  import(
    "@/views/pages/inventory/components/inventory-campaign/InventoryCreateBook"
  );
// const FeedbackIndex = () => import("@/views/pages/feedback/Index");
// const FeedbackDetail = () => import("@/views/pages/feedback/Details");
const ShippingIndex = () => import("@/views/pages/shipping/Index");
const PromotionIndex = () => import("@/views/pages/promotion/Index");
const PromotionDetail = () => import("@/views/pages/promotion/Details");
const FinanceIndex = () => import("@/views/pages/finance/Index");
const FinanceOrderListIndex = () => import("@/views/pages/finance-order-list/Index");
const FinanceDetail = () => import("@/views/pages/finance/Details");
const FinanceCreate = () => import("@/views/pages/finance/components/finance-create/FinanceCreate.vue");
const AdminIndex = () => import("@/views/pages/admin/Index");
const AdminDetail = () => import("@/views/pages/admin/components/admin-detail/AdminDetail");
const Page404 = () => import("@/views/pages/Page404");
const Page500 = () => import("@/views/pages/Page500");
const Login = () => import("@/views/pages/Login");
const Welcome = () => import("@/views/pages/Welcome");

Vue.use(Router);

export default new Router({
  mode: "history",
  linkActiveClass: "active",
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: "/login",
      name: "Login",
      component: Login,
      meta: { requiresIsLogin: true },
    },
    {
      path: "/d-order",
      name: "d-order",
      permission: 51,
    },
    {
      path: "/d-chatbot",
      name: "d-chatbot",
      permission: 50,
    },
    {
      path: "/",
      redirect: "/welcome",
      name: "หน้าแรก",
      component: TheContainer,
      meta: { requiresAuth: true, lv: 1, activeUrl: "/welcome" },
      children: [
        {
          path: "welcome",
          redirect: "/welcome",
          name: "",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "",
              name: "welcome",
              component: Welcome,
              meta: {
                requiresAuth: true,
                isChildren: true,
                activeUrl: "/welcome",
              },
            },
          ],
        },
        {
          path: "product",
          redirect: "/product",
          name: "",
          permission: 7,
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "",
              name: "สินค้า",
              component: ProductIndex,
              meta: {
                requiresAuth: true,
                isChildren: true,
                activeUrl: "/product",
                lv: 2,
              },
              permission: 7,
            },
            {
              path: "details/:id",
              name: "รายละเอียดสินค้า",
              component: ProductDetail,
              meta: {
                requiresAuth: true,
                isChildren: true,
                activeUrl: "/product",
                lv: 2,
              },
              permission: 7,
            },
          ],
        },
        {
          path: "order",
          redirect: "/order",
          name: "",
          component: {
            permission: 10,
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "",
              name: "รายการคำสั่งซื้อ",
              component: OrderIndex,
              meta: {
                requiresAuth: true,
                isChildren: true,
                activeUrl: "/order",
                lv: 2,
              },
              permission: 10,
            },
            {
              path: "main/details/:id",
              name: "รายละเอียดคำสั่งซื้อหลัก",
              component: OrderDetail,
              meta: {
                requiresAuth: true,
                isChildren: true,
                activeUrl: "/order",
                lv: 2,
              },
              permission: 10,
            },
            {
              path: "details/:id",
              name: "รายละเอียดคำสั่งซื้อ",
              component: OrderDetail,
              meta: {
                requiresAuth: true,
                isChildren: true,
                activeUrl: "/order",
                lv: 2,
              },
              permission: 10,
            },
          ],
        },
        {
          path: "inventory",
          redirect: "/inventory",
          name: "",
          permission: 56,
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "",
              name: "การกระจายสินค้า",
              component: InventoryIndex,
              meta: {
                requiresAuth: true,
                isChildren: true,
                activeUrl: "/inventory",
                lv: 2,
              },
              permission: 56,
            },
            {
              path: "config/:id",
              name: "ตั้งค่าการกระจายสินค้า",
              component: InventoryAutoConfig,
              meta: {
                requiresAuth: true,
                isChildren: true,
                activeUrl: "/inventory",
                lv: 2,
              },
              permission: 56,
            },
            {
              path: "create-campaign/:id",
              name: "สร้างแคมเปญ",
              component: InventoryCreateBook,
              meta: {
                requiresAuth: true,
                isChildren: true,
                activeUrl: "/inventory",
                lv: 2,
              },
              permission: 56,
            },
          ],
        },
        {
          path: "shipping",
          redirect: "/shipping",
          name: "",
          permission: 43,
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "",
              name: "การจัดส่ง",
              component: ShippingIndex,
              meta: {
                requiresAuth: true,
                isChildren: true,
                activeUrl: "/shipping",
                lv: 2,
              },
              permission: 43,
            },
          ],
        },
        {
          path: "promotion",
          redirect: "/promotion",
          name: "",
          permission: 9,
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "",
              name: "โปรโมชัน",
              component: PromotionIndex,
              meta: {
                requiresAuth: true,
                isChildren: true,
                activeUrl: "/promotion",
                lv: 2,
              },
              permission: 9,
            },
            {
              path: "details/:id",
              name: "รายละเอียดโปรโมชัน",
              component: PromotionDetail,
              meta: {
                requiresAuth: true,
                isChildren: true,
                activeUrl: "/promotion",
                lv: 2,
              },
              permission: 9,
            },
          ],
        },
        {
          path: "finance",
          redirect: "/finance",
          name: "",
          permission: 53,
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "",
              name: "รายการธุรกรรม",
              component: FinanceIndex,
              meta: {
                requiresAuth: true,
                isChildren: true,
                activeUrl: "/finance",
                lv: 2,
              },
              permission: 53,
            },
            {
              path: "details/:id",
              name: "รายละเอียดธุรกรรม",
              component: FinanceDetail,
              meta: {
                requiresAuth: true,
                isChildren: true,
                activeUrl: "/finance",
                lv: 2,
              },
              permission: 53,
            },
            {
              path: "order-list",
              name: "ภาพรวมการสั่งซื้อ",
              component: FinanceOrderListIndex,
              meta: {
                requiresAuth: true,
                isChildren: true,
                activeUrl: "/finance/order-list",
                lv: 2,
              },
            },
            {
              path: "create-finance/:id",
              name: "รายการธุรกรรมใหม่",
              component: FinanceCreate,
              meta: {
                requiresAuth: true,
                isChildren: true,
                activeUrl: "/finance",
                lv: 2,
              },
              permission: 53,
            },
          ],
        },
        {
          path: "admin",
          redirect: "/admin",
          name: "",
          permission: 22,
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "",
              name: "รายการผู้ดูแลระบบ",
              component: AdminIndex,
              meta: {
                requiresAuth: true,
                isChildren: true,
                activeUrl: "/admin",
                lv: 2,
              },
              permission: 22,
            },
            {
              path: "details/:id",
              name: "รายละเอียดผู้ดูแลระบบ",
              component: AdminDetail,
              meta: {
                requiresAuth: true,
                isChildren: true,
                activeUrl: "/admin",
                lv: 2,
              },
              permission: 22,
            },
          ],
        },
      ],
    },
    {
      path: "*",
      name: "Page404",
      component: Page404,
    },
  ],
});
